import { Divider, Space } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import DetailPageHeader from '../components/detail-page-header';
import WarehouseProductsTable from '../components/downloader/warehouse-products-table';
import UpdatedAt from '../components/updated-at';
import WarehouseProductFilter from '../components/warehouse-product/filter';
import { type RootState } from '../reducers';
import { downloaderLoadWarehouseProducts } from '../reducers/downloader/reducer';
import { SPACING } from '../theme/tokens';

function DownloaderWarehouseProducts(): React.ReactElement {
  const downloaderWarehouseProducts = useSelector(
    (s: RootState) => s.Downloader.warehouse.products,
  );
  const downloaderUpdatedAt = useSelector(
    (s: RootState) => s.Downloader.updatedAt,
  );

  const productCount = downloaderWarehouseProducts?.length ?? 0;
  const pageHeaderText = `Downloader warehouse products${productCount ? ` (${productCount} items)` : ''}`;

  return (
    <Space size={SPACING.lg} orientation="vertical" style={{ width: '100%' }}>
      <DetailPageHeader title={pageHeaderText} />

      <Space
        size={SPACING.lg}
        align="center"
        separator={<Divider orientation="vertical" />}
      >
        <WarehouseProductFilter cb={downloaderLoadWarehouseProducts} />

        <UpdatedAt value={downloaderUpdatedAt} />
      </Space>

      <WarehouseProductsTable />
    </Space>
  );
}

export default DownloaderWarehouseProducts;
